import ApiService from "../services/api";
import { Consultant, ConsultantFormData } from "../models/consultant";

export interface ConsultantsPaginationData {
  consultants: Consultant[];
  totalElements: number;
  totalPages: number;
}

export const fetchConsultants = async (params: { page?: number, limit?: number, search?: string }): Promise<ConsultantsPaginationData> => {
  const apiService = new ApiService();

  try {
    const response = await apiService.get<any>(`/users/consultants/all`, { params });
    if (response.status !== 200) throw new Error("Error fetching consultants");

    const consultants = response.data.items.map((consultant: any) => ({
      id: consultant.id,
      firstName: consultant.firstName,
      lastName: consultant.lastName,
      accountId: consultant.accountId,
      email: consultant.email,
      phoneNumber: consultant.phoneNumber,
      dn: consultant.dn,
      specialist: consultant.specialist,
      groupConsultant: consultant.groupConsultant,
      sendEmail: consultant.sendEmail,
      createdAt: consultant.createdAt ? new Date(consultant.createdAt) : undefined,
      updatedAt: consultant.updatedAt ? new Date(consultant.updatedAt) : undefined,
    }));

    return {
      consultants,
      totalElements: response.data.totalItems || 0,
      totalPages: response.data.totalPages || 0,
    };
  } catch (error) {
    console.error('Error fetching consultants:', error);
    return {
      consultants: [],
      totalElements: 0,
      totalPages: 0,
    };
  }
};

export const createConsultant = async (data: ConsultantFormData): Promise<Consultant | null> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.post<any>('/users/consultants', data);
    if (response.status !== 200) throw new Error("Error creating consultant");
    
    return {
      id: response.data.id,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      accountId: response.data.accountId,
      email: response.data.email,
      phoneNumber: response.data.phoneNumber,
      dn: response.data.dn,
      specialist: response.data.specialist,
      groupConsultant: response.data.groupConsultant,
      sendEmail: response.data.sendEmail,
      createdAt: response.data.createdAt ? new Date(response.data.createdAt) : undefined,
      updatedAt: response.data.updatedAt ? new Date(response.data.updatedAt) : undefined,
    };
  } catch (error) {
    console.error('Error creating consultant:', error);
    throw error;
  }
};

export const updateConsultant = async (id: string, data: ConsultantFormData): Promise<Consultant | null> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.post<any>(`/users/consultants`, {...data, id});
    if (response.status !== 200) throw new Error("Error updating consultant");
    
    return {
      id: response.data.id,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      accountId: response.data.accountId,
      email: response.data.email,
      phoneNumber: response.data.phoneNumber,
      dn: response.data.dn,
      specialist: response.data.specialist,
      groupConsultant: response.data.groupConsultant,
      sendEmail: response.data.sendEmail,
      createdAt: response.data.createdAt ? new Date(response.data.createdAt) : undefined,
      updatedAt: response.data.updatedAt ? new Date(response.data.updatedAt) : undefined,
    };
  } catch (error) {
    console.error('Error updating consultant:', error);
    throw error;
  }
};

export const deleteConsultant = async (id: string): Promise<boolean> => {
  const apiService = new ApiService();
  
  try {
    const response = await apiService.delete(`/users/consultants/${id}`);
    return response.status === 200;
  } catch (error) {
    console.error('Error deleting consultant:', error);
    return false;
  }
};
